import React from "react";
import { DocumentDownload } from "iconsax-react";

interface FileAttachmentProps {
  fileName: string;
  mimeType: string;
  fileUrl: string;
}

const FileAttachment: React.FC<FileAttachmentProps> = ({ fileName, mimeType, fileUrl }) => {
  const isImage = mimeType.startsWith("image/");
  const isPDF = mimeType === "application/pdf";
  const isDocument = mimeType.includes("word") || mimeType.includes("document");
  const isSpreadsheet = mimeType.includes("sheet") || mimeType.includes("excel");

  const getFileIcon = () => {
    if (isImage) return "🖼️";
    if (isPDF) return "📄";
    if (isDocument || isSpreadsheet) return "📊";
    return "📎";
  };

  const handleDownload = async () => {
    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
      window.open(fileUrl, "_blank");
    }
  };

  const handlePreview = () => {
    window.open(fileUrl, "_blank");
  };

  return (
    <div className="mt-2">
      {isImage ? (
        <div className="relative max-w-xs group">
          <img src={fileUrl} alt={fileName} className="w-full transition-all rounded-md cursor-pointer hover:shadow-md" onClick={handlePreview} loading="lazy" />
          <div className="absolute transition-opacity opacity-0 top-2 right-2 group-hover:opacity-100">
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleDownload();
              }}
              className="p-2 transition-all bg-black rounded-lg bg-opacity-60 hover:bg-opacity-80"
              title={`Download ${fileName}`}
            >
              <DocumentDownload className="text-white size-5" variant="Bold" />
            </button>
          </div>
        </div>
      ) : isPDF || isDocument || isSpreadsheet ? (
        <div className="flex items-center gap-3 p-2 border rounded-md bg-gorgonzola-blue-50 border-gorgonzola-blue-100">
          <div className="flex-shrink-0 text-2xl">{getFileIcon()}</div>
          <div className="flex-grow min-w-0">
            <p className="text-xs font-medium truncate text-closed-shutter-300">{fileName}</p>
            <p className="text-xs truncate text-closed-shutter-200">{mimeType}</p>
          </div>
          <button onClick={handleDownload} className="flex-shrink-0 p-2 transition-colors rounded-lg bg-gorgonzola-blue-300 hover:bg-gorgonzola-blue-400" title={`Download ${fileName}`}>
            <DocumentDownload className="text-white size-5" variant="Bold" />
          </button>
        </div>
      ) : (
        <button
          onClick={handleDownload}
          className="flex items-center gap-2 px-3 py-2 text-sm transition-all border rounded-md border-gorgonzola-blue-100 bg-gorgonzola-blue-50 hover:bg-gorgonzola-blue-200 hover:shadow-sm text-closed-shutter-300"
          title={`Download ${fileName}`}
        >
          {getFileIcon()}
          <span className="truncate max-w-[200px]">{fileName}</span>
        </button>
      )}
    </div>
  );
};

export default FileAttachment;
